<template>
  <v-btn icon elevation="0" @click="$emit('click')">
    <v-icon>
      vertical_align_top
    </v-icon>
  </v-btn>
</template>

<script>
  export default {
    name: "ExpandBuildingButton"
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/ExpandBuildingButton.vue